import { TaskRequestApi } from "../DTO/ClientRequest/TaskRequest";
import {
  isTaskWithTagsAndIllustrationsWithContentResponseDTO,
  TaskWithTagsAndIllustrationsAndModulesResponseApi,
  TaskWithContent,
} from "../DTO/ServerResponseType/Task/Task";
import {
  isTaskDataToCreateResponseDTO,
  TaskDataToCreateResponseApi,
} from "../DTO/ServerResponseType/Task/TaskDataToCreate";
import {
  isTaskIdResponseDTO,
  TaskIdApi,
} from "../DTO/ServerResponseType/Task/TaskId";
import { TaskStatusEnum } from "../Enums/TaskStatuses";
import { ServerClient, serverOrigin } from "./Configs";
import {
  getTypeGuardedArrayVariableAsync,
  getTypeGuardedVariableAsync,
} from "./typeGuard";

class TaskServerClient {
  path = "/task";

  async sendToGetAllTasksAsync(
    withDeepData: boolean = false
  ): Promise<TaskWithContent[] | never> {
    let url: string =
      serverOrigin + this.path + "/show/all?withDeepData=" + withDeepData;

    let responseBody: TaskWithContent[] =
      await getTypeGuardedArrayVariableAsync(
        ServerClient.sendRequestAsync({
          url: url,
          method: "GET",
          credentials: "include",
        }),
        isTaskWithTagsAndIllustrationsWithContentResponseDTO
      );

    return responseBody;
  }

  async sendToDeleteTaskAsync(taskId: string): Promise<unknown> {
    let url: string = serverOrigin + this.path + "/delete";

    let sendPromise = ServerClient.sendRequestAsync({
      url: url,
      method: "POST",
      body: JSON.stringify({ taskId: taskId }),
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    });

    return sendPromise.catch((error) => {
      console.error("Ошибка:", error);
    });
  }

  sendToUpdateTaskAsync = async (
    taskId: string,
    taskNewData: TaskRequestApi
  ): Promise<null> => {
    await this.sendUpdatedTaskAsync(taskId, taskNewData)
      .then(() => {
        alert("Задача успешно изменена.");
      })
      .catch((error) => {
        console.error("Ошибка:", error);
      });

    return null;
  };

  sendUpdatedTaskAsync = async (
    taskId: string,
    taskNewData: TaskRequestApi
  ): Promise<unknown> => {
    let url: string = serverOrigin + this.path + "/update/all";

    let response = await ServerClient.sendRequestAsync({
      url: url,
      method: "POST",
      body: JSON.stringify({
        taskId: taskId,
        taskNewData: taskNewData,
      }),
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    });

    return response;
  };

  sendToUpdateTaskStatusAsync = async (
    taskId: string,
    taskStatusId: TaskStatusEnum
  ): Promise<void> => {
    await this.sendUpdatedTaskStatusAsync(taskId, taskStatusId)
      .then(() => {
        alert("У задачи успешно изменен статус");
      })
      .catch((error) => {
        console.error("Ошибка:", error);
      });
  };

  sendUpdatedTaskStatusAsync = async (
    taskId: string,
    taskStatusId: TaskStatusEnum
  ): Promise<void> => {
    let url: string = serverOrigin + this.path + "/update/status";
    await ServerClient.sendRequestAsync({
      url: url,
      method: "POST",
      body: JSON.stringify({
        taskId: taskId,
        taskStatusId: taskStatusId,
      }),
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    });
  };

  sendToGetTaskByTaskIdAsync = async (
    taskId: string
  ): Promise<TaskWithTagsAndIllustrationsAndModulesResponseApi | never> => {
    let url: string = serverOrigin + this.path + "/show/one?taskId=" + taskId;

    let task: TaskWithTagsAndIllustrationsAndModulesResponseApi =
      await getTypeGuardedVariableAsync(
        ServerClient.sendRequestAsync({
          url: url,
          method: "GET",
          credentials: "include",
        }),
        isTaskWithTagsAndIllustrationsWithContentResponseDTO
      );

    return task;
  };

  sendToCreateTaskAsync = async (
    taskData: TaskRequestApi
  ): Promise<string | null> => {
    let taskId: string | null = await getTypeGuardedVariableAsync(
      this.sendNewTaskAsync(taskData),
      isTaskIdResponseDTO
    )
      .then((taskIdDTO: TaskIdApi) => {
        alert("Задача успешно создана.");
        return taskIdDTO.taskId;
      })
      .catch((error) => {
        console.error("Ошибка:", error);
        return null;
      });

    return taskId;
  };

  sendNewTaskAsync = async (taskData: TaskRequestApi): Promise<unknown> => {
    let url: string = serverOrigin + this.path + "/create";

    let response = await ServerClient.sendRequestAsync({
      url: url,
      method: "POST",
      body: JSON.stringify(taskData),
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    });

    return response;
  };

  sendToGetDataToCreateTaskAsync = async (): Promise<
    TaskDataToCreateResponseApi | never
  > => {
    let url: string = serverOrigin + this.path + "/data/toCreate";

    let taskDataToCreate: TaskDataToCreateResponseApi =
      await getTypeGuardedVariableAsync(
        ServerClient.sendRequestAsync({
          url: url,
          method: "GET",
          credentials: "include",
        }),
        isTaskDataToCreateResponseDTO
      ).catch((error) => {
        console.error("Ошибка:", error);
        throw error;
      });

    return taskDataToCreate;
  };
}

let taskServerClient = new TaskServerClient();

export default taskServerClient;
